import React from 'react';
import { LinearProgress as LProgress } from "@mui/material";

interface ILinearProgressProps {
    className?: string;
}

export const LinearProgress: React.FC<ILinearProgressProps> = ({
                                                                        className
                                                                    }) => (
    <div className={className}>
        <LProgress color="secondary"/>
    </div>
);

